module.exports = __webpack_public_path__ + "img/Familia_2.e3bba9b4.jpg";